import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SignUp.css';

import { ApiContext } from '../context/ApiContext';
const SignUp = () => {
    const navigate = useNavigate();
    const apiUrl = useContext(ApiContext);
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleCreate = async () => {
        if (password !== confirmPassword) {
            alert('Passwords do not match!');
            return;
        }

        try {
            const response = await fetch(`${apiUrl}/api/v1/signup`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, username, password }),
            });

            if (response.ok) {
                alert('Sign Up Successful!');
                navigate('/posts');
            } else {
                alert('Sign Up Failed!');
            }
        } catch (error) {
            console.error('Error during sign up:', error);
            alert('An error occurred. Please try again.');
        }
    };

    return (
        <div className="SignUp">
            <h2>Sign Up</h2>
            <form>
                <div>
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Username:</label>
                    <input
                        type="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Password:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Confirm Password:</label>
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="form-buttons">
                    <button type="button" onClick={() => window.history.back()}>Cancel</button>
                    <button type="button" onClick={handleCreate}>Create</button>
                </div>
            </form>
        </div>
    );
};

export default SignUp;
